module.exports = __webpack_public_path__ + "img/danyi.8cb7926e.png";